import BaseController from "controllers/backend/base"

import ResultsFilterWidget from "widgets/backend/resultsFilterWidget"

class Controller extends BaseController {
  call() {
    super.call()
    bindResultsFilter.call(this)
  }
};

var bindResultsFilter = function() {
  let elem = this.root.find('#results')
  this.resultsFilter = new ResultsFilterWidget(elem)
}

export default Controller;
